import { formProcessor } from "./onLoad";
import { getQueryParam } from "../native/utility";
import {
	getEncryptedMessage,
	getFromLocalStorage,
	removeFromLocalStorage,
	setInLocalStorage,
} from "./utility";
import { getRandomString } from "./utility";
import {
	LEAD_DATA_STORAGE_MODULE_NAME,
	LEAD_DATA_STORAGE_KEY_NAME,
	SPACE,
	userIdentifierTypeA,
	userIdentifierTypeV,
} from "../common/constants";

const handleNestedKeys = (data, allkeys, targetValue) => {
	if (allkeys.length > 0) {
		allkeys.reduce(function (obj, next) {
			if (allkeys[allkeys.length - 1] == next)
				return (obj[next] = getApiValueKeys(targetValue));
			else return (obj[next] = {});
		}, data);
	}
	return data;
};
const getParamString = async (params) => {
	if (!params) return undefined;

	let str = "";
	for (const i of params) {
		const value = await getApiValueKeys(i.value);
		str = str ? `${str}&${i.key}=${value}` : `?${i.key}=${value}`;
	}
	return str;
};

const isNumeric = (value) => {
	return !isNaN(parseInt(value)) ? true : false;
};

/* make it more generic */
const checkIfValidStringKey = (stringKey, fieldData) => {
	let value = formProcessor.getField(fieldData.id);
	const keyArr = stringKey.split(".");
	while (keyArr.length != 0) {
		const obj = keyArr.shift();
		if (value[obj]) value = value[obj];
	}
	return value;
};

const createAppendedItemObject = (valueObj) => {
	const resultObj = {};
	if (valueObj) {
		const valueArr = Object.keys(valueObj);
		for (let key of valueArr) {
			const field = formProcessor.getValueFieldMap(key);
			if (field?.appendById && field?.attributes?.dependantType) {
				resultObj[valueObj[field.fieldId]] =
					valueObj[field?.attributes?.dependantType] || 0;
			}
		}
	}

	return resultObj;
};

const cleanIntValue = (remvalue) => {
	if (remvalue) {
		remvalue = remvalue.replaceAll("-", " ");
		remvalue = remvalue.replaceAll(" ", "");
	}
	return remvalue;
}
const getApiValueKeys = (initialValue, fieldData) => {
	let value;
	const valueLocator = String(initialValue).trim();
	if (valueLocator.indexOf("$.form") === 0) {
		const remvalue = valueLocator.substring(7);
		if (remvalue.includes("helperData")) {
			let val = remvalue.substring(5);
			const field = formProcessor.getFieldValue(remvalue.substring(0, 4));
			val = val.replace("helperData", "");
			val = val.replaceAll(".", "");
			value = field.helperData[val];
		}
		else if (isNumeric(remvalue)) {
			value = formProcessor.getFieldValue(remvalue);
		} else {
			value = checkIfValidStringKey(remvalue, fieldData);
		}
	} else if (valueLocator.indexOf("$.digicodeverifier") == 0) {
		const rem = getRandomString();
		value = rem.hashed;
		removeFromLocalStorage("", "digicodeverifier");
		setInLocalStorage("", "digicodeverifier", { key: rem.randomString });
	} else if (valueLocator.indexOf("$.date:time") == 0) { 
		const currentDate = new Date();
		value = `${`${currentDate.getDate()}-${(currentDate.getMonth() + 1).toString().padStart(2,'0')}-${currentDate.getFullYear()}`} ${`${currentDate.getHours()}:${currentDate.getMinutes().toString().padStart(2,'0')}:${currentDate.getSeconds()}`}`;
	} else if (valueLocator.indexOf("$.encrypt") === 0) {
		const fieldValue = valueLocator.replace("encrypt.", "");
		const key = fieldValue.substring(7);
		let remvalue = getApiValueKeys(`$.localStorage.${LEAD_DATA_STORAGE_MODULE_NAME}${LEAD_DATA_STORAGE_KEY_NAME}.${key}temporaryValue`);
		if(!remvalue) remvalue = formProcessor.getFieldValue(key);
		else remvalue = getApiValueKeys(`$.localStorage.${LEAD_DATA_STORAGE_MODULE_NAME}${LEAD_DATA_STORAGE_KEY_NAME}.${key}originalValue`);
		remvalue = cleanIntValue(remvalue)
		value = getEncryptedMessage(remvalue);
	} else if (valueLocator.indexOf("$.userIdentifierType") === 0) {
		const fieldValue = valueLocator.replace("userIdentifierType.", "");
		let remvalue = formProcessor.getFieldValue(fieldValue.substring(7));
		remvalue = cleanIntValue(remvalue)
		value = remvalue.length == 12 ? userIdentifierTypeA : userIdentifierTypeV;
	} else if (valueLocator.indexOf("$") !== 0) {
		value = valueLocator === SPACE ? "" : initialValue;
	} else if (valueLocator.indexOf("$.query") === 0) {
		value = getQueryParam(valueLocator.substring(8));
	} else if (valueLocator.indexOf("$.localStorage.digicodeverifier") === 0) {
		const str = getFromLocalStorage("", "digicodeverifier");
		value = str.key;
	} else if (valueLocator.indexOf("$.localStorage.") === 0) {
		const remArr = valueLocator.substring(15).split(".");
		const storageKey = remArr.shift();
		const str = getFromLocalStorage("", storageKey);
		let val = str;
		while (remArr.length != 0) {
			const toCheck = remArr.shift();
			if (toCheck && val) {
				val = val[toCheck];
			} else break;
		}
		if (typeof val == "object") {
			value = createAppendedItemObject(val);
		} else value = val;
	}

	return value;
};

const objectMapping = (currentObject, updatedObject) => {
	if (updatedObject && currentObject) {
		for (let key in updatedObject) {
			currentObject[key] = updatedObject[key];
		}

		return currentObject;
	}
};

const createFieldMap = (objectArr) => {
	if (objectArr.length > 0) {
		const objectMap = new Map();
		objectArr.forEach((item) => {
			const fieldValue = formProcessor.getFieldValue(item);
			objectMap.set(item, fieldValue ? true : false);
		});
		return objectMap;
	}
	return new Map();
};

const removeSpaces = (str) => {
	if (str) {
		return str.replaceAll(" ", "");
	}
	return str;
};

const parseSubtitle = (str) => {
	let fieldId = str.substring(str.indexOf("[") + 1, str.indexOf("]"));
	if (fieldId.indexOf("$.form") === 0) {
		fieldId = fieldId.substring(7);
		const field = formProcessor.getField(fieldId);
		if (field) {
			const value = field.fieldValue
			const toReplaceBy = [str.substring(0, str.indexOf("[")), value];
			return toReplaceBy;
		}
	}
};

const parseLabelNextLine = (str) => {
	return str.replaceAll("\\n", "\n");
};

const parseText = (str) => {
	let valueOf = str.substring(str.indexOf("[") + 1, str.indexOf("]"));
	if (valueOf.indexOf("$.localStorage.") === 0) {
		let newvalue = getApiValueKeys(valueOf) || "";
		str = str.replace(valueOf, newvalue);
		str = str.replace("[", "");
		str = str.replace("]", "");
		str = str.replace(/\s+/g, ' ')
		if(str.indexOf("[") !== 0 ) {
			return parseText(str)
		}
	}
	else if (valueOf.indexOf("$.form.") === 0) {
		let newvalue = getApiValueKeys(valueOf) || "";
		str = str.replace(valueOf, newvalue);
		str = str.replace("[", "");
		str = str.replace("]", "");
		if(str.indexOf("[") !== 0 ) {
			return parseText(str)
		}
	}
	return str;
};

const findKeyInResponse = (obj, searchKey, results = []) => {
	const arr = results;
	if(obj && Object.keys(obj).length > 0) {
		Object.keys(obj).forEach((key) => {
			const value = obj[key];
			if(value && value !== null) {
				if (key === searchKey && typeof value !== "object") {
					arr.push(value);
				} else if (typeof value === "object") {
					findKeyInResponse(value, searchKey, arr);
				}
			}
		});
	}
	return arr;
};

const addItemsToFetchedLeadData = (key, value) => {
	const parsedObject = getFromLocalStorage(
		LEAD_DATA_STORAGE_MODULE_NAME,
		LEAD_DATA_STORAGE_KEY_NAME
	);
	parsedObject[key] = value;
	setInLocalStorage(
		LEAD_DATA_STORAGE_MODULE_NAME,
		LEAD_DATA_STORAGE_KEY_NAME,
		parsedObject
	);
};

const getFilterArrayValues = (fieldData) => {
	const arr = formProcessor.getField(fieldData?.attributes?.filter?.targetField)?.filter?.options || [];
	let str = "";
	if (arr && arr.length > 0) {
		arr.forEach((element) => {
			str = str + element.value + ","
		});
	}
	return str;
}

const getMaskedValue = (value) => {
	if (value) {
		value = value.replaceAll("-", "");
		value = value.replaceAll(" ", "");
		value = value.replace(/\d(?=\d{4})/g, "*");
	}
	return value;
}

const removeUrlParameter = (paramKey) => {
	const url = window.location.href
	var r = new URL(url)
	r.searchParams.delete(paramKey)
	const newUrl = r.href
	window.history.pushState({ path: newUrl }, '', newUrl)
}

const digiLockerReset = () => {
	removeUrlParameter("code");
	removeUrlParameter("state");
	removeUrlParameter("jti");
	localStorage.removeItem("digicodeverifier");
}

export {
	getApiValueKeys,
	handleNestedKeys,
	getParamString,
	objectMapping,
	createFieldMap,
	removeSpaces,
	parseSubtitle,
	parseLabelNextLine,
	findKeyInResponse,
	addItemsToFetchedLeadData,
	parseText,
	getFilterArrayValues,
	getMaskedValue,
	removeUrlParameter,
	digiLockerReset
};
